import { useMemo, useState } from 'react'
import ComboBoxComponent, { ComboboxProps } from './shared/styled/ComboBoxComponent'
import { OptionType } from 'types/OptionType'

export type ComboProps = {
  options: OptionType[]
} & ComboboxProps

export default function Combo(props: ComboProps) {
  const [query, setQuery] = useState(``)
  const filteredOptions = useMemo(
    () =>
      query === ``
        ? props.options
        : props.options.filter((option) => {
            return (
              option.name?.toLowerCase().includes(query.toLowerCase()) ||
              (typeof option.value === `string` && option.value?.toLowerCase().includes(query.toLowerCase()))
            )
          }),
    [query, props.options],
  )

  return (
    <ComboBoxComponent
      {...props}
      onClearSearch={() => setQuery(``)}
      onSearchValueChange={setQuery}
      options={filteredOptions}
    />
  )
}
